// api
import { fetchApi } from '@/api'
// actions

const academicBlockProductsShow = (context,data) => {
  let url = 'academic/validatecredential/' + data.credential + ''
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ACADEMIC_BLOCK_PRODUCTS', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const academicBlockProductsStore = (context,data) => {
  let url = 'academic/productsblock'
  return fetchApi(url, data, 'POST')
    .then((response) => {
      context.commit('ACADEMIC_BLOCK_PRODUCTS', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const academicBlockProductsList = (context,data) => {
  let url = 'cafeteria/locked/products/'+data.id_user_primary
  return fetchApi(url, {}, 'GET')
    .then((response) => {
      context.commit('ACADEMIC_BLOCK_PRODUCTS', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const academicBlockStudentList = (context,data) => {
  let url = 'lock/students'
  return fetchApi(url, {}, 'POST')
    .then((response) => {
      context.commit('ACADEMIC_BLOCK_PRODUCTS', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

export default {
  academicBlockProductsShow,
  academicBlockProductsStore,
  academicBlockProductsList,
  academicBlockStudentList
}



// WEBPACK FOOTER //
// ./src/store/modules/academic/block_products/actions.js